import React from 'react';
import PropTypes from 'prop-types';
import HeaderBar from 'components/headerBar';
import Carousel from 'components/Carousel';
import BulkActivityInput from 'views/Roster/timeline/activityForm/BulkActivityInput';
import { Badge, Icon } from 'antd';

const ActivitiesPanel = ({
  headerTitle, itemRenderer, onCancel, onDeselect, onSave, selectedObjects, selectedItems, title, showAdminNotes
}) => (
  <>
    <div>
      <BulkActivityInput
        isEditMode
        canAdmin
        showAdminNotes={showAdminNotes}
        onSaveClick={onSave}
        onCancelClick={onCancel}
        title={title}
      />
    </div>
    <HeaderBar
      title={[<Badge key={selectedObjects.length} count={selectedObjects.length} />, ' ', headerTitle]}
    />
    <Carousel
      columns={6}
      extra={item => (
        <a onClick={() => onDeselect(item.key)}>
          <Icon type="select" />
          {' '}
          Deselect
        </a>
      )}
      items={selectedItems}
      style={{ marginBottom: '20px' }}
      itemRenderer={item => itemRenderer(item)}
    />
  </>
);

ActivitiesPanel.propTypes = {
  headerTitle: PropTypes.string,
  itemRenderer: PropTypes.func,
  onCancel: PropTypes.func,
  onDeselect: PropTypes.func,
  onSave: PropTypes.func,
  selectedObjects: PropTypes.array,
  selectedItems: PropTypes.array,
  title: PropTypes.string,
  showAdminNotes: PropTypes.bool,
};

ActivitiesPanel.defaultProps = {
  headerTitle: 'Selected Assignments',
  itemRenderer() {
  },
  onCancel() {
  },
  onDeselect() {
  },
  onSave() {
  },
  selectedObjects: [],
  selectedItems: [],
  title: 'Activities',
  showAdminNotes: false,
};

export default ActivitiesPanel;
